import { useState } from "react";
import { Button, Card, Form, Input, Modal, Space, Table } from "antd";
import { PageHeader } from "../../shared/ui/PageHeader";
import { DataCard } from "../../shared/ui/DataCard";
import { useIsMobile } from "../../shared/hooks/useIsMobile";
import {
  useCreateMotorista,
  useDeleteMotorista,
  useMotoristas,
  useUpdateMotorista,
} from "./hooks";

export default function Motoristas() {
  const isMobile = useIsMobile();
  const [form] = Form.useForm();
  const [editMotorista, setEditMotorista] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const { data: motoristas = [], isLoading } = useMotoristas();
  const createMutation = useCreateMotorista();
  const updateMutation = useUpdateMotorista();
  const deleteMutation = useDeleteMotorista();

  const addMotorista = (values) => {
    createMutation.mutate(values, { onSuccess: () => form.resetFields() });
  };

  const saveEdit = (values) => {
    updateMutation.mutate(
      { id: editMotorista.id, ...values },
      { onSuccess: () => setEditMotorista(null) },
    );
  };

  const confirmDelete = () => {
    deleteMutation.mutate(deleteId, { onSettled: () => setDeleteId(null) });
  };

  const columns = [
    { title: "Nome", dataIndex: "nome", key: "nome" },
    { title: "E-mail", dataIndex: "email", key: "email" },
    {
      title: "Ações",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button type="primary" onClick={() => setEditMotorista(record)}>
            Editar
          </Button>
          <Button danger onClick={() => setDeleteId(record.id)}>
            Excluir
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="te-page-wrap te-stack">
      <PageHeader
        title="Motoristas"
        subtitle="Cadastre, edite e remova os motoristas que operam o fluxo de retirada."
        metricLabel="Motoristas cadastrados"
        metricValue={motoristas.length}
      />

      <Card className="te-card">
        <div style={{ marginBottom: 18 }}>
          <h3 style={{ margin: 0, color: "var(--te-primary)" }}>Novo motorista</h3>
          <p className="te-kicker">Crie acessos para quem vai operar as retiradas.</p>
        </div>

        <Form layout="vertical" form={form} onFinish={addMotorista}>
          <div className="te-form-grid te-form-grid--compact">
            <Form.Item name="nome" label="Nome" rules={[{ required: true, message: "Informe o nome" }]}>
              <Input size="large" placeholder="Nome completo" />
            </Form.Item>
            <Form.Item name="email" label="E-mail" rules={[{ required: true, message: "Informe o e-mail" }]}>
              <Input size="large" placeholder="email@trocaenvio.com" />
            </Form.Item>
            <Form.Item name="senha" label="Senha" rules={[{ required: true, message: "Informe a senha" }]}>
              <Input.Password size="large" placeholder="Senha temporária" />
            </Form.Item>
          </div>

          <div className="te-form-action" style={{ marginTop: 6 }}>
            <Button type="primary" htmlType="submit" loading={createMutation.isPending}>
              Adicionar motorista
            </Button>
          </div>
        </Form>
      </Card>

      <Card className="te-card">
        <div style={{ marginBottom: 16 }}>
          <h3 style={{ margin: 0, color: "var(--te-primary)" }}>Lista de motoristas</h3>
          <p className="te-kicker">Edite rapidamente os dados cadastrais dos acessos ativos.</p>
        </div>
        {isMobile ? (
          isLoading ? (
            <div className="te-empty">Carregando...</div>
          ) : (
            <div className="te-stack">
              {motoristas.map((motorista) => (
                <DataCard
                  key={motorista.id}
                  title={motorista.nome}
                  rows={[{ label: "E-mail", value: motorista.email }]}
                  actions={
                    <>
                      <Button type="primary" onClick={() => setEditMotorista(motorista)}>
                        Editar
                      </Button>
                      <Button danger onClick={() => setDeleteId(motorista.id)}>
                        Excluir
                      </Button>
                    </>
                  }
                />
              ))}
            </div>
          )
        ) : (
          <Table
            dataSource={motoristas}
            columns={columns}
            rowKey={(record) => record.id}
            loading={isLoading}
            pagination={{ pageSize: 8, showSizeChanger: false }}
          />
        )}
      </Card>

      <Modal
        title="Editar motorista"
        open={!!editMotorista}
        onCancel={() => setEditMotorista(null)}
        footer={null}
      >
        {editMotorista && (
          <Form
            initialValues={{ nome: editMotorista.nome, email: editMotorista.email }}
            onFinish={saveEdit}
            layout="vertical"
          >
            <Form.Item name="nome" label="Nome" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name="email" label="E-mail" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name="senha" label="Nova senha">
              <Input.Password placeholder="Opcional" />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit" loading={updateMutation.isPending}>
                  Salvar
                </Button>
                <Button onClick={() => setEditMotorista(null)}>Cancelar</Button>
              </Space>
            </Form.Item>
          </Form>
        )}
      </Modal>

      <Modal
        title="Confirmar exclusão"
        open={!!deleteId}
        onOk={confirmDelete}
        onCancel={() => setDeleteId(null)}
        okText="Excluir"
        okButtonProps={{ danger: true, loading: deleteMutation.isPending }}
        cancelText="Cancelar"
      >
        <p>Tem certeza que deseja excluir este motorista?</p>
      </Modal>
    </div>
  );
}
